import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import compose from '../../hoc/compose';
import template from '../panelHeader.jsx';

var PanelHeader = /*#__PURE__*/function (_React$Component) {
  _inherits(PanelHeader, _React$Component);

  var _super = _createSuper(PanelHeader);

  function PanelHeader() {
    _classCallCheck(this, PanelHeader);

    return _super.apply(this, arguments);
  }

  _createClass(PanelHeader, [{
    key: "getClassName",
    value: function getClassName() {
      var _this$props = this.props,
          className = _this$props.className,
          onBack = _this$props.onBack,
          theme = _this$props.theme,
          removeStripe = _this$props.removeStripe,
          removeDivider = _this$props.removeDivider;
      var themeClassName = "theme-".concat(theme);
      return classNames(className, 'panel-header', 'panel-header-flex', themeClassName, {
        'has-back': onBack,
        'without-stripe': removeStripe,
        'without-divider': removeDivider
      });
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return PanelHeader;
}(React.Component);

PanelHeader.displayName = 'PanelHeader';
PanelHeader.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,

  /** Callback function, triggered when clicking on the header */
  onMouseDown: PropTypes.func,

  /** Callback function. When passed display a back button icon. Triggered when clicking on the back button. */
  onBack: PropTypes.func,

  /** Callback function. Triggered when clicking on the help icon button */
  onHelp: PropTypes.func,

  /** Callback function. Triggered when clicking on the close icon button */
  onClose: PropTypes.func,

  /** When set to true removes the close icon button */
  noCloseBtn: PropTypes.bool,

  /** When set to true removes the help icon button */
  noHelpBtn: PropTypes.bool,
  style: PropTypes.object,

  /** When passed, overrides the default close icon */
  closeSymbol: PropTypes.element,

  /** When passed, overrides the default help icon */
  helpSymbol: PropTypes.element,

  /** Set the color of the strip - work only for Classic Facelift skin */
  theme: PropTypes.oneOf(['standard', 'destructive', 'premium']),

  /** Tooltip to display when hovering over the back icon button */
  backTooltipContent: PropTypes.string,

  /** A placeholder for a component that can contain buttons / anything else */
  actionsBar: PropTypes.node,

  /** Remove the color stripe on the top of the Panel Header. Classic Facelift Skin only */
  removeStripe: PropTypes.bool,

  /** Remove the divider on the bottom of the Panel Header. Classic Facelift Skin only */
  removeDivider: PropTypes.bool,

  /**
   * Automation ID - for testing purposes, please use dataHook instead
   * @deprecated
   */
  backAutomationId: PropTypes.string
};
PanelHeader.defaultProps = {
  dataHook: 'panel-header',
  theme: 'standard',
  removeStripe: false,
  removeDivider: false
};
export default compose(PanelHeader);